import React from 'react';

import { useRegisterEditableWidget } from '@lumapps/designer-legacy-widget-settings/hooks/useEditableWidget';
import type { EditableWidgetProps } from '@lumapps/designer-legacy-widget-settings/types';
import { BackendRecomputedWidget } from '@lumapps/widget-base/components/BackendRecomputedWidget';

import { LegacyWidgetFeaturedImageProps } from '../../type';
import { EditableWidgetFeaturedImage, EditableWidgetFeaturedImageProps } from '../EditableWidgetFeaturedImage';

export interface LegacyWidgetFeaturedImageWrapperProps extends EditableWidgetProps<LegacyWidgetFeaturedImageProps> {
    editableWidgetProps?: EditableWidgetFeaturedImageProps;
}

export interface EditableWidgetFeaturedImageProperties {}

export const LegacyWidgetFeaturedImageWrapper: React.FC<LegacyWidgetFeaturedImageWrapperProps> = ({
    legacyWidget,
    isEditingContent = false,
    isWidgetEmpty,
    ...props
}) => {
    useRegisterEditableWidget(legacyWidget);

    return (
        <BackendRecomputedWidget<
            LegacyWidgetFeaturedImageProps,
            EditableWidgetFeaturedImageProperties,
            EditableWidgetFeaturedImageProps
        >
            legacyWidget={legacyWidget}
            editableWidgetRenderer={EditableWidgetFeaturedImage}
            shouldUpdateWhileEditing
            isWidgetEmpty={isWidgetEmpty}
            editingContent={isEditingContent}
            {...props}
        />
    );
};
